import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export const companyProfileTitleScrollFill = () => {
  const title = document.getElementById("company-profile-title");
  const section = document.getElementById("company-profile");

  if (!title || !section) return;

  const lagStrength = 0.07;
  let grayProgress = 0;
  let greenProgress = 0;
  let targetProgress = 0;
  let previousProgress = 0;
  let scrollDirection = 1;

  title.style.setProperty("--title-fill-progress-gray", "0%");
  title.style.setProperty("--title-fill-progress-green", "0%");

  const clampProgress = gsap.utils.clamp(0, 100);

  const setGray = (value: number) => {
    grayProgress = value;
    title.style.setProperty("--title-fill-progress-gray", `${value}%`);
  };

  const setGreen = (value: number) => {
    greenProgress = value;
    title.style.setProperty("--title-fill-progress-green", `${value}%`);
  };

  const tick = () => {
    const ratio = gsap.ticker.deltaRatio();
    const easedLag = 1 - Math.pow(1 - lagStrength, ratio);

    if (scrollDirection < 0) {
      setGreen(targetProgress);
      setGray(grayProgress + ((targetProgress - grayProgress) * easedLag));
      return;
    }

    setGray(targetProgress);
    setGreen(greenProgress + ((targetProgress - greenProgress) * easedLag));
  };

  gsap.ticker.add(tick);

  const syncProgress = (progress: number) => {
    const delta = progress - previousProgress;
    if (Math.abs(delta) > 0.01) {
      scrollDirection = delta > 0 ? 1 : -1;
    }
    previousProgress = progress;
    targetProgress = progress;
  };

  const refreshProgress = (progress: number) => {
    previousProgress = progress;
    targetProgress = progress;
    setGray(progress);
    setGreen(progress);
  };

  const createTrigger = (triggerElement: HTMLElement, start: string, end: string) =>
    ScrollTrigger.create({
      trigger: triggerElement,
      start,
      end,
      onUpdate: (self) => {
        syncProgress(clampProgress(self.progress * 100));
      },
      onRefresh: (self) => {
        refreshProgress(clampProgress(self.progress * 100));
      },
    });

  const media = gsap.matchMedia();
  let trigger: ScrollTrigger | null = null;

  media.add("(min-width: 768px)", () => {
    trigger = createTrigger(section, "top 80%", "bottom 75%");

    return () => {
      trigger?.kill();
      trigger = null;
    };
  });

  media.add("(max-width: 767px)", () => {
    trigger = createTrigger(title, "top 85%", "bottom 55%");

    return () => {
      trigger?.kill();
      trigger = null;
    };
  });

  return () => {
    gsap.ticker.remove(tick);
    media.revert();
    trigger?.kill();
  };
};
